import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import { granularityLevelSchema } from '../shared/schemes.js';

const MetricSchema = z.object({
  label: z.string(),
  name: z.string(),
  required: z.boolean(),
  headerType: z.enum(['metric', 'dimension']),
  expectDateOrder: z.boolean(),
  expectNumberFormat: z.boolean(),
});

export type SystemMetric = z.infer<typeof MetricSchema>;

const MetricsQuerySchema = z.object({
  granularityLevelType: granularityLevelSchema.nullable(),
});

const MetricsResponseSchema = z.object({
  data: z.object({
    items: z.array(MetricSchema),
    additional: z.object({
      customMetrics: z.array(MetricSchema).readonly(),
      maxCount: z.number().optional(),
    }),
  }),
});

export type MetricsResponse = z.infer<typeof MetricsResponseSchema>;
export type MetricsQueryResult = MetricsResponse['data'];

export const getSystemMetricsQueryOptions = defaultClient.query({
  url: 'data-ingestion/tabledatafile/granularity/headers-meta/' as const,
  method: 'GET',
  querySchema: MetricsQuerySchema,
  responseSchema: MetricsResponseSchema,
  snakeCaseQueryParams: true,
  processResponse(data): MetricsQueryResult {
    return data.data;
  },
  keyPrefix: ['metricsList'],
});

export const getDataFileSystemMetricsQueryOptions = defaultClient.query({
  url: 'data-ingestion/tabledatafile/$id/headers-meta/' as const,
  method: 'GET',
  querySchema: MetricsQuerySchema,
  responseSchema: MetricsResponseSchema,
  snakeCaseQueryParams: true,
  processResponse(data): MetricsQueryResult {
    return data.data;
  },
  keyPrefix: ['metricsList'],
});

export const getTemplateMetricsQueryOptions = defaultClient.query({
  url: 'data-ingestion/activity/$activityId/headers-meta/' as const,
  method: 'GET',
  querySchema: z.object({
    granularityLevel: granularityLevelSchema,
  }),
  responseSchema: MetricsResponseSchema,
  snakeCaseQueryParams: true,
  processResponse(data): MetricsQueryResult {
    return data.data;
  },
  keyPrefix: ['metricsList'],
});
